import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentosService } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-actualizaservicioexterno',
  templateUrl: './actualizaservicioexterno.component.html',
  styles: []
})
export class ActualizaServicioExternoComponent implements OnInit {

  forma: FormGroup;
  ido: string;
  service: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private documentosService: DocumentosService,
    public router: Router
  ) { }


  ngOnInit() {

      this.ido = this.route.snapshot.paramMap.get('id');

      this.forma = new FormGroup({
        Name: new FormControl( null , Validators.required ),
        Descripcion: new FormControl( null , Validators.required )
      } );

      this.documentosService.getExtService( this.ido ).subscribe( resp => { this.service = resp; console.log(resp) },
        err => {
          console.clear();
          console.log("ocurrio un error");
          // console.log(err); 
      } );

  }


  actualizaService() {

    // Obtener el elemento por el id
    const Proveedor: any = document.getElementById('Proveedor');
    const Usuario: any = document.getElementById('Usuario');
    const Api_key: any = document.getElementById('Api_key');
    const Token: any = document.getElementById('Token');
    const URL: any = document.getElementById('URL');
    const Regla: any = document.getElementById('Regla');
    // Obtener el valor de la opción seleccionada

    const valorProveedor = Proveedor.value;
    const valorUsuario = Usuario.value;
    const valorApikey = Api_key.value;
    const valorToken = Token.value;
    const valorURL = URL.value;
    const valorRegla = Regla.value;

    const params = {
      supplier: valorProveedor,
      user: valorUsuario,
      api_key: valorApikey,
      token: valorToken,
      url: valorURL,
      rule: valorRegla,
      secret_key: ''
    }

    this.documentosService.actualizaExtService( this.ido, params ).subscribe( () => {
    Swal.fire({
      title: 'Modificacion de servicio exitosa',
      text: '',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this.router.navigate(['/panelcontrol/serviciosexternos']);
      }

    } );

  }, (err) => {             console.clear();
    // console.log(err);
                            Swal.fire(
                              'Error al modificar servicio',
                              'Error',
                              'error'
                           );
                        } );

  }


}
